import React, { useEffect, useState } from "react";
import actions from "../../../redux/actions";
import { useSelector } from "react-redux";
import HomeFooter from "../../../components/HomeFooter";
import { useToast } from "../../../components/ToastContext";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { useLocationPermission } from "../../../hooks/useLocationPermission";
import LocationPermissionModal from "../../../components/Modal/LocationPermissionModal";
import TwoFactorService from "../../../services/twoFactorService";

const SignIn = () => {
  const { login } = useAuth(); // Access login function from context

  const { showToast } = useToast();
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState({
    username: "",
    password: "",
    LatLong: "",
  });
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [ip, setIp] = useState(null);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [show2FAModal, setShow2FAModal] = useState(false);
  const [tempToken, setTempToken] = useState("");
  const [twoFactorCode, setTwoFactorCode] = useState("");
  const [isVerifying2FA, setIsVerifying2FA] = useState(false);
  const [twoFactorError, setTwoFactorError] = useState("");
  const newsRaw = useSelector((state) => state.marketSlice?.newsData?.Result);
  const news = Array.isArray(newsRaw) ? newsRaw : [];

  const getHostname = () => {
    try {
      var host = window.location.hostname;
      const dots = host.split(".");
      return dots.at(-2).replace(/\d/g, "");
    } catch (ex) {}
  };
  // Use the location permission hook
  const {
    latitude,
    longitude,
    permissionStatus,
    isPermissionCheckComplete,
    errorMessage,
    retry: retryLocation,
    isLocationAvailable,
  } = useLocationPermission();

  useEffect(() => {
    // Fetch IP Address
    fetch("https://ipinfo.io/json")
      .then((response) => response.json())
      .then((data) => setIp(data.ip))
      .catch((error) => console.error("Error fetching IP:", error));

    // Load username from localStorage if "Remember Me" was selected
    const savedUsername = localStorage.getItem("rememberedUsername");
    if (savedUsername) {
      setData((prevData) => ({ ...prevData, username: savedUsername }));
      setRememberMe(true);
    }

    // Show location modal if permission check is complete and location is not available
    if (getHostname() == "goldexch" || getHostname() == "kiki") {
    } else {
      if (isPermissionCheckComplete && !isLocationAvailable) {
        setShowLocationModal(true);
      } else if (isPermissionCheckComplete && isLocationAvailable) {
        setShowLocationModal(false);
      }
    }
  }, [isPermissionCheckComplete, isLocationAvailable]);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!data.username.trim()) {
      showToast("Username is required", "error");
      return;
    }
    if (!data.password.trim()) {
      showToast("Password is required", "error");
      return;
    }
    if (getHostname() == "goldexch" || getHostname() == "kiki") {
    } else {
      if (!isLocationAvailable) {
        showToast(
          "Location permission is required to log in. Please enable location services.",
          "error",
        );
        setShowLocationModal(true);
        return;
      }
    }
    setIsLoading(true);
    try {
      const res = await actions.loginAction({
        data: { ...data, LatLong: `${latitude},${longitude}` },
        ip,
      });
      if (!res?.data?.Status) {
        showToast(
          res?.data?.Result || "Login failed. Please try again.",
          "error",
        );
      } else if (res.status === 200) {
        if (res.data?.Requires2FA) {
          setTempToken(res.data.TempToken);
          setTwoFactorCode("");
          setTwoFactorError("");
          setShow2FAModal(true);
          return;
        }
        login(res.data);
        if (rememberMe) {
          localStorage.setItem("rememberedUsername", data.username);
        } else {
          localStorage.removeItem("rememberedUsername");
        }
        navigate(`/home`);
      }
    } catch (error) {
      const errorMessage =
        error?.message || "An unexpected error occurred. Please try again.";
      showToast(errorMessage, "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleVerify2FA = async (e) => {
    if (e) e.preventDefault();
    if (!twoFactorCode || twoFactorCode.trim().length < 6) {
      setTwoFactorError("Please enter your 6-digit code or recovery code.");
      return;
    }
    setIsVerifying2FA(true);
    setTwoFactorError("");
    try {
      const res = await TwoFactorService.verifyLogin(
        tempToken,
        twoFactorCode.trim(),
      );
      if (res?.data?.Status && res?.data?.Token) {
        login(res.data);
        if (rememberMe) {
          localStorage.setItem("rememberedUsername", data.username);
        } else {
          localStorage.removeItem("rememberedUsername");
        }
        setShow2FAModal(false);
        navigate(`/home`);
      } else {
        setTwoFactorError(
          res?.data?.Result ||
            res?.data?.Message ||
            "Invalid code. Please try again.",
        );
      }
    } catch (err) {
      setTwoFactorError("Failed to verify code. Please check your connection.");
    } finally {
      setIsVerifying2FA(false);
    }
  };

  const handleChange = (e) => {
    let { value, name } = e.target;
    setData({ ...data, [name]: value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleLoginClick = () => {
    navigate("/login");
  };

  return (
    <div>
      <LocationPermissionModal
        show={showLocationModal}
        onRetry={retryLocation}
        permissionStatus={permissionStatus}
        errorMessage={errorMessage}
        isLoading={isLoading}
      />
      {/* Header */}
      <header
        className={`pk d-flex flex-column align-items-center position-fixed ${getHostname()} `}
      >
        <div className="container-fluid d-flex align--center py-1">
          <div className="d-flex align-items-center logo_area ps-2 ps-md-3 ps-lg-0">
            <img
              src={`/assets/images/${getHostname()}.png`}
              alt="logo"
              className="w-100"
            />
          </div>
          <div className="right_area d-flex align-items-center order-lg-3 ms-auto ps-2">
            <ul className="ps-0">
              <li className="open">
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn loginBtn text-white f-14"
                    onClick={handleLoginClick}
                  >
                    Login
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="marquee_area d-flex align-items-center w-100">
          {" "}
          <span className="ic">
            {" "}
            <img src="./assets/img/speaker_blue.png" alt="" />{" "}
          </span>
          <div className="scrolling-text">{news ? news[0]?.Message : ""}</div>
        </div>
      </header>

      {/* Main Content */}
      <div
        className="main"
        style={{
          backgroundImage: "url('/assets/images/login_bg-compress.jpg')",
        }}
      >
        <div className="container">
          <div className="login">
            <div className="login_form mt-2 p-2">
              <div className="logo_area">
                <img src={`/assets/images/${getHostname()}.png`} alt="" />
              </div>
              <form
                noValidate=""
                className="danger ng-untouched ng-pristine ng-invalid"
              >
                <div className="withEmail">
                  <div className="form-field d-flex align-items-center">
                    {" "}
                    <span className="ic">
                      {" "}
                      <i className="fa-solid fa-user" />{" "}
                    </span>
                    <div className="d-flex w-100">
                      <input
                        type="text"
                        placeholder="Enter Username"
                        value={data.username}
                        name="username"
                        onChange={handleChange}
                        formcontrolname="user_name"
                        className="form-control w-100 m_field ng-untouched ng-pristine ng-invalid"
                      />{" "}
                    </div>
                  </div>
                  <div className="form-field d-flex align-items-center mb-2 position-relative">
                    {" "}
                    <span className="ic">
                      {" "}
                      <i className="fa-solid fa-lock" />
                    </span>
                    <input
                      type={showPassword ? "text" : "password"}
                      value={data.password}
                      name="password"
                      onChange={handleChange}
                      placeholder="Enter Password"
                      formcontrolname="password"
                      className="form-control ng-untouched ng-pristine ng-invalid"
                    />
                    <button
                      type="button"
                      className="btn eye_ic"
                      onClick={togglePasswordVisibility}
                    >
                      <i
                        className={`fa-solid ${
                          showPassword ? "fa-eye-slash" : "fa-eye"
                        } ng-star-inserted icon-black`}
                      />
                    </button>
                  </div>
                </div>

                <div className="form-field d-flex flex-column mb-1 pt-2 mt-3">
                  <label className="d-flex">
                    <input
                      type="checkbox"
                      name="rememberMe"
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                      className="me-2"
                    />
                    Remember me
                  </label>
                </div>
                <div className="form-field d-flex flex-column mb-2 mt-3">
                  <button
                    type="submit"
                    className="btn submit_btn"
                    onClick={handleLogin}
                    disabled={isLoading}
                  >
                    {isLoading ? "Loading..." : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Two-Factor Authentication Login Verification Modal */}
      {show2FAModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.65)", zIndex: 1060 }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            style={{ maxWidth: "390px" }}
          >
            <div
              className="modal-content"
              style={{
                borderRadius: "8px",
                border: "1px solid #444",
                boxShadow: "0 10px 25px rgba(0,0,0,0.5)",
              }}
            >
              <div className="modal-header bg-dark text-white p-3 d-flex justify-content-between align-items-center">
                <h5
                  className="modal-title m-0"
                  style={{ fontSize: "16px", color: "#fff" }}
                >
                  <i
                    className="fa fa-shield me-2"
                    style={{ color: "#f0ad4e" }}
                  />{" "}
                  Two-Factor Verification
                </h5>
                <button
                  type="button"
                  className="close text-white"
                  style={{
                    background: "transparent",
                    border: "none",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                  onClick={() => setShow2FAModal(false)}
                >
                  &times;
                </button>
              </div>
              <div className="modal-body p-4 text-center">
                <p
                  style={{
                    fontSize: "13px",
                    color: "#444",
                    marginBottom: "16px",
                  }}
                >
                  Enter the 6-digit code from your{" "}
                  <strong>Google Authenticator</strong> app (or an emergency
                  backup code):
                </p>
                {twoFactorError && (
                  <div
                    className="alert alert-danger p-2 mb-3"
                    style={{ fontSize: "12px" }}
                  >
                    {twoFactorError}
                  </div>
                )}
                <form onSubmit={handleVerify2FA}>
                  <input
                    type="text"
                    maxLength="12"
                    autoFocus
                    placeholder="000000"
                    className="form-control text-center mb-3"
                    style={{
                      fontSize: "22px",
                      letterSpacing: "4px",
                      fontWeight: "bold",
                    }}
                    value={twoFactorCode}
                    onChange={(e) => setTwoFactorCode(e.target.value)}
                  />
                  <div className="d-flex justify-content-between mt-3">
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() => setShow2FAModal(false)}
                      disabled={isVerifying2FA}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-warning modal-btn btn-sm"
                      style={{ fontSize: "13px", padding: "6px 18px" }}
                      disabled={isVerifying2FA || !twoFactorCode.trim()}
                    >
                      {isVerifying2FA ? "Verifying..." : "Verify & Log In"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      <HomeFooter />
    </div>
  );
};

export default SignIn;
